export default {
  date: 'May 30, 2024',
  title: 'New video: discover everything about our "render set"!',
  description: 'The "Render Set" offers a unique opportunity to purchase high-quality interior renderings of residential properties, along with 2D and 3D floor plans',
  id: 'render-set',
  jsx: () => (
    <div class='novelty__text'>
      <p>The "Render Set" offers a unique opportunity to purchase high-quality interior renderings of residential properties, along with 2D and 3D floor plans. This package is designed for those who value quality and want to showcase real estate in the best possible light.</p>
      <p>Benefits of High-Quality Renderings for Real Estate Sales:</p>
      <p>
        <u>Attracting Attention</u>: Beautiful and realistic images capture the interest of potential buyers, creating an unforgettable first impression.
      </p>
      <p>
        <u>Demonstrating Potential</u>: Renderings help show how a space can be furnished, which is especially important for empty or under-construction properties.
      </p>
      <p>
        <u>Emotional Engagement</u>: Realistic visualizations evoke an emotional response, allowing potential buyers to imagine themselves in their new home.
      </p>
      <p>
        <u>Increasing Sales</u>: Studies show that high-quality renderings can speed up the sales process and increase the transaction value.
      </p>
      <p>
        <u>Convenience for Online Presentations</u>: In today's world, many buyers start their property search online. High-quality renderings make online presentations more attractive and informative.
      </p>
      <p>Want to learn more about the "Render Set"? Watch our video for all the details!</p>
    </div>
  ),
  thumb: 'news/19.webp',
  video: 'https://www.youtube.com/embed/EgthefVRr2s?si=ZHOSfDoQFOYcVCMa',
};
